import { AllNotifyPartyResponse, CommonResponse, NotifyPartyDto, NotifyPartyResponse,NotifypartyRequest } from '@gtpl/shared-models/masters';
import axios from 'axios';
import connection from './connection';


export class NotifyPartyService {
    URL = connection.DEPLOY_URL + '/notify-party'

    async createNotifyParty(dto: NotifyPartyDto): Promise<NotifyPartyResponse> {
        return await axios.post(this.URL + '/createNotifyParty', dto)
            .then(res => {
                return res.data
            })
    }
    async updateNotifyParty(dto: NotifyPartyDto): Promise<NotifyPartyResponse> {
        return await axios.post(this.URL + '/updateNotifyParty', dto)
            .then(res => {
                return res.data
            })
    }
    async activatedeActivateNotifyParty(Dto: NotifyPartyDto): Promise<NotifyPartyResponse> {
        return await axios.post(this.URL + '/activatedeActivateNotifyParty', Dto)
            .then(res => {
                return res.data
            })
    }
    async getAllNotifyParty(): Promise<AllNotifyPartyResponse> {
        return await axios.post(this.URL + '/getAllNotifyParty')
            .then(res => {
                return res.data
            })
    }
    async getAllNotifyPartyDropDown(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllNotifyPartyDropDown')
            .then(res => {
                return res.data
            })
    }

    async getTrimsInfoById(NotifyPartyReq: NotifypartyRequest): Promise<NotifyPartyResponse> {
        return await axios.post(this.URL + '/getNotifyPartyInfoById', NotifyPartyReq)
            .then(res => {
                return res.data
            })
    }

}